// @ts-nocheck
import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import ConfirmDialog from "./ConfirmDialog";

const ConfirmDialogContext = createContext(null);

export function ConfirmDialogProvider({ children }) {
  const [request, setRequest] = useState(null);

  const confirm = useCallback((options) => {
    return new Promise((resolve) => {
      setRequest({
        title: "Are you sure?",
        description: "Please confirm this action.",
        confirmLabel: "Confirm",
        cancelLabel: "Cancel",
        variant: "default",
        ...options,
        resolve,
      });
    });
  }, []);

  const close = useCallback((value) => {
    setRequest((current) => {
      current?.resolve(value);
      return null;
    });
  }, []);

  const value = useMemo(() => ({ confirm }), [confirm]);

  return (
    <ConfirmDialogContext.Provider value={value}>
      {children}
      <ConfirmDialog
        open={!!request}
        onOpenChange={(open) => {
          if (!open) close(false);
        }}
        title={request?.title || "Are you sure?"}
        description={request?.description || "Please confirm this action."}
        confirmLabel={request?.confirmLabel || "Confirm"}
        cancelLabel={request?.cancelLabel || "Cancel"}
        variant={request?.variant || "default"}
        onConfirm={() => close(true)}
      />
    </ConfirmDialogContext.Provider>
  );
}

export function useConfirmDialog() {
  const context = useContext(ConfirmDialogContext);
  if (!context) {
    throw new Error("useConfirmDialog must be used within ConfirmDialogProvider");
  }
  return context.confirm;
}

export default ConfirmDialogProvider;
